// removed by extract-text-webpack-plugin
module.exports = {"accordionHeading":"Z98oka-09UVNyUpu9kTND","accordingText":"DApF-pWBN9USKzzOAhbOn","smallAccordion":"_8M4vPTzXPBI-h4vOm8kAc","infoText":"_2bAUfUdKmZ7GtP3OuOsc7H"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/SetTokenAllowanceTrust.scss
// module id = 1238
// module chunks = 0